import PropTypes from "prop-types";
import React, { useEffect, useContext } from "react";
import { Dialog, Backdrop } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { withSnackbar } from "../../HOC/withSnackbar";
import GeofencePackageProgress from "./GeofencePackageProgress";
import GeofencePackageVersionForm from "./GeofencePackageVersionForm";
import { GeofencePackageContext } from "../../context";
import { saveFileToDisk, parseError } from "./ExportJSON";
import { errorMessageBuilder } from "../../util/helpers";

const ModalBackdrop = styled(Backdrop)`
  position: absolute;
  z-index: 2;

  > * {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const ModalDialog = styled(Dialog)`
  width: 100vw;
`;

const GeofencePackageCreationModal = ({ setSnackbarMessage }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const { allSteps, currentStep, kickOffPackageCreation, fileContentToSave, error, reset } =
    useContext(GeofencePackageContext);

  const handleClose = () => {
    history.goBack();
    setTimeout(() => reset(), 1000);
  };

  useEffect(() => {
    if (fileContentToSave) {
      const { mimeType, fileName } = fileContentToSave;
      let { content } = fileContentToSave;
      if (currentStep === "DOWNLOADING_RULECHAIN") {
        // Attempt to pretty print the json for visual inspection
        try {
          const parsed = JSON.parse(content);
          content = JSON.stringify(parsed, null, " ");
        } catch (err) {
          console.error("Rulechain file was not properly formatted json");
        }
      }
      saveFileToDisk(content, fileName, mimeType);
    }
  }, [fileContentToSave]);

  useEffect(() => {
    if (!error) return;

    const parsed = parseError(error);

    const errorMessage = errorMessageBuilder(
      t("Fleet.Geofences.ExportModal.DownloadRequestFailure"),
      parsed.response.status,
      parsed.message,
    );
    setSnackbarMessage(errorMessage);
  }, [error]);

  return (
    <ModalBackdrop open>
      <ModalDialog
        open
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {currentStep === allSteps.VERSION_DIALOG ? (
          <GeofencePackageVersionForm
            visible
            handleSubmit={(version) => {
              kickOffPackageCreation(version);
            }}
            handleClose={handleClose}
          />
        ) : (
          <GeofencePackageProgress open step={currentStep} handleClose={handleClose} />
        )}
      </ModalDialog>
    </ModalBackdrop>
  );
};

GeofencePackageCreationModal.propTypes = {
  setSnackbarMessage: PropTypes.func.isRequired,
};

export default withSnackbar(GeofencePackageCreationModal);
